export default "__VITE_ASSET__19463d24__"